<template>
  <!--  <Card>-->
  <!--    <template #content>-->
  <div class="p-grid ">
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="box bgPersonal">
        <h4 class="titleColor">Personal Info</h4>
        <hr/>
        <div class="p-fluid ">
          <div class="p-field p-grid">
            <label for="firstname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">EmpName</label>
            <div class="p-col-12 p-md-10">
              <span>Sushant Shiwakoti(0003)</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Mobile</label>
            <div class="p-col-12 p-md-10">
              <span>9843263274</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Email</label>
            <div class="p-col-12 p-md-10">
              <span>sushntcc@gmail.com</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">BloodGroup</label>
            <div class="p-col-12 p-md-10">
              <span>0+</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="box bgPersonal">
        <h4 class="titleColor">Positions & Jobs</h4>
        <hr/>
        <div class="p-fluid ">
          <div class="p-field p-grid">
            <label for="firstname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Designation</label>
            <div class="p-col-12 p-md-10">
              <span>Software Engineer</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">JobTitle</label>
            <div class="p-col-12 p-md-10">
              <span>-</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Type</label>
            <div class="p-col-12 p-md-10">
              <span>Permanent</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Status</label>
            <div class="p-col-12 p-md-10">
              <span>Working</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">EmpGroup</label>
            <div class="p-col-12 p-md-10">
              <span>-</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Supervisor</label>
            <div class="p-col-12 p-md-10">
              <span>Sushant shiwakoti<br/> </span>
              <span class="pi pi-mobile"></span> 9802345678
              <span class="pi pi-envelope"></span> sushant.shiwakoti@digiconnect.com.np
            </div>
          </div>
          <!--              <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-5"></label>-->
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-4">
      <div class="box bgPersonal">
        <h4 class="titleColor">Locations</h4>
        <hr/>
        <div class="p-fluid">
          <div class="p-field p-grid">
            <label for="firstname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Branch</label>
            <div class="p-col-12 p-md-10">
              <span>Sushant Shiwakoti(0003)</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Department</label>
            <div class="p-col-12 p-md-10">
              <span>9843263274</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Unit</label>
            <div class="p-col-12 p-md-10">
              <span>sushntcc@gmail.com</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Division</label>
            <div class="p-col-12 p-md-10">
              <span>0+</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">BusinessUnit</label>
            <div class="p-col-12 p-md-10">
              <span>0+</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Supervisor2</label>
            <div class="p-col-12 p-md-10">
              <span>0+</span>
            </div>
          </div>
          <div class="p-field p-grid">
            <label for="lastname" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">ServicePerid</label>
            <div class="p-col-12 p-md-10">
              <span> 1years 30 days</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-12">
        <a style="float: right" href="">View Full Profile</a>
    </div>
  </div>
</template>
<!--  </Card>-->
<!--</template>-->

<script>
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'

export default {
  name: 'profile',
  data() {
    return {}
  },
  components: {
    Card,
    InputText
  }
}
</script>

<style scoped>
.titleColor {
  font-size: 2em;
  font-family: Arial;
  color: #3c8dbc;
}

.bgPersonal {
  height: 22em;
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// profile.vue?77f372ba